module.exports = __webpack_public_path__ + "static/media/massive_star_otype.3ee1fbc0.png";